import { render, staticRenderFns } from "./BtnAtualizarDotacaoPadrao.vue?vue&type=template&id=8168864e&"
import script from "./BtnAtualizarDotacaoPadrao.vue?vue&type=script&lang=js&"
export * from "./BtnAtualizarDotacaoPadrao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports